module.exports = "<hybse-admin-company [isDemo]=\"true\"></hybse-admin-company>\n"


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/components/pages/demo-company/demo-company.component.html
// module id = ../../../../../src/app/components/pages/demo-company/demo-company.component.html
// module chunks = main